@if (initialized && model) {
  <div>
    @if (model.subscription && step === 'confirm') {
      <app-cancel-number-confirmation
        (back)="resetWorkflow()"
        [block]="model.block"
        [cancellationDate]="model.subscription?.nextPossibleDowngradeDate"
        (confirmed)="onCancellationConfirmed($event)">
      </app-cancel-number-confirmation>
    }
    @if (step === 'address') {
      <app-invoice-address
        (next)="onInvoiceAddress($event)"
        (backEvent)="onInvoiceAddressBack()"
        [historyBack]="false">
      </app-invoice-address>
    }
    @if (isSepa && step === 'payment') {
      <app-payment-method
        (next)="onPaymentMethod($event)"
        [onlyEmit]="true"
        (backEvent)="onPaymentMethodBack()"
        [historyBack]="false"
        [paymentMethod]="model?.saleOrder?.payment_method ?? model?.subscription?.payment_method">
      </app-payment-method>
    }
    @if (model.subscription && step === 'checkout-summary') {
      <app-checkout-one-summary
        backLabel="app_cancel"
        [historyBack]="false"
        [subscription]="model.subscription"
        (back)="onSummaryBack()"
        (buy)="onSummaryBuy()">
      </app-checkout-one-summary>
    }
    @if (step === 'complete') {
      <app-endcustomer-cancel-phonenumber-order-complete
        [block]="model.block"
        (next)="onComplete()">
      </app-endcustomer-cancel-phonenumber-order-complete>
    }
  </div>
}